import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useRef } from "react";
import { useContext } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import ReactPlayer from "react-player";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { io } from "socket.io-client";
import swal from "sweetalert";
import noImage from "../../.../../../../../../assets/images/settings/no-image.png";
import { serverInfo } from "../../../../../../App";
import useFileHandleS3 from "../../../../../../CustomHooks/useFileHandleS3";
import MediaUploadProgressBar from "../../../../../../Screen/MediaUploadProgressBar";

const CreateEditSouvenir = () => {
  const { imageCdnUrl } = useContext(serverInfo);
  const location = useLocation();

  const history = useHistory();

  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [viewSouviner, setViewSouviner] = useState({});
  const [description, setDescription] = useState();
  const [instruction, setInstruction] = useState();
  const [title, setTitle] = useState();
  const [price, setPrice] = useState();
  const [tax, setTax] = useState();
  const [starId, setStarId] = useState();
  const [errorList, setError] = useState([]);
  const [starList, setStarList] = useState([]);

  // File Handle
  const fileInputRef = useRef(null);
  const [filePath, setFilePath] = useState("");
  const [file, setFile] = useState("");
  const [delKey, setDelKey] = useState(null);
  const [fileUrl,fileKey,progress] = useFileHandleS3(file,'souvenir/images',delKey);

  const handleImageChange = (file) => {
    setDelKey(fileKey);
    setFile(file[0]);
  };
  const deleteFile = ()=>
  {
    setFile(null);
    setDelKey(fileKey);
    fileInputRef.current.value = '';

  }
  useEffect(() => {
    axios.get(`/api/admin/view-category`).then((res) => {
      if (res.status === 200) {
        setStarList(res.data.allStar);
      }
    });
  }, []);

  useEffect(() => {
    if (location.pathname === `/superstar-admin/souvenir/edit/${id}`) {
      axios.get(`/api/admin/souviner/view/${id}`).then((res) => {
        if (res.status === 200) {
          setViewSouviner(res.data?.viewSouviner);
          setDescription(res.data.viewSouviner?.description);
          setInstruction(res.data.viewSouviner?.instruction);
          setTitle(res.data.viewSouviner?.title);
          setPrice(res.data.viewSouviner?.price);
          setTax(res.data.viewSouviner?.tax);
          setStarId(res.data.viewSouviner?.star_id);
          setFilePath(res.data.viewSouviner?.banner)
        }
      });
    }

    setDescription("");
    setInstruction("");
    setTitle("");
    setPrice("");
    setTax("");
    setFilePath("");
    // setVideo("");
    setStarId("");
  }, []);

  const socket = useRef();
  /**
   * socket connection
   */
  const { shoketUrl } = useContext(serverInfo);
  useEffect(() => {
    socket.current = io(shoketUrl);
  }, []);

  const actionSouviner = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();

    formData.append("description", description);
    formData.append("instruction", instruction);
    formData.append("title", title);
    formData.append("star_id", starId);

    formData.append("price", price);
    formData.append("tax", tax);
    formData.append("banner", fileKey?fileKey:filePath);
    // formData.append("video", video);

    if (id) {
      axios.post(`/api/admin/souviner/update/${id}`, formData).then((res) => {
        setLoading(false);
        if (res.data.status === 200) {
          if(file){
            setFile('');
            setDelKey(filePath.split("com/").pop())
          }
          setError([]);
          history.push("/superstar-admin/souvenir");
          swal("Welcome", res.data.message, "success");
        } else {
          setError(res.data.validation_errors);

          // error_list: res.data.validation_errors,
        }
      });
    } else {
      axios.post(`/api/admin/souviner/store`, formData).then((res) => {
        setLoading(false);
        if (res.data.status === 200) {
          setDescription("");
          setInstruction("");
          setTitle("");
          setPrice("");
          setTax("");

          setError([]);
          swal("Welcome", res.data.message, "success");
          history.push("/superstar-admin/souvenir");

          socket.current.emit("souvenir_approve", {
            id: res.data.souvenirId,
          });
        } else {
          setError(res.data.validation_errors);

          // error_list: res.data.validation_errors,
        }
      });
    }
  };

  return (
    <div className="">
      <div className="text-light d-flex border border-warning rounded-3 justify-content-center p-2 m-1">
        <div className="faTrophy">
          <i className="fa-solid fa-calendar-plus mx-2"></i>
        </div>
        {location.pathname === `/superstar-admin/souvenir/edit/${id}` ? (
          <h3 className="text-warning text-bold">Edit default Souvenir</h3>
        ) : (
          <h3 className="text-warning text-bold">Create Default Souvenir</h3>
        )}
      </div>
      <div className="card card-bg mb-2 p-2 ">
        <div className="card card-bg m-2">
          <div className="container-lg">
            <div className="row">
              <div className="clo-sm-12 col-md-12 col-lg-9 mx-auto">
                <form id="input_form" onSubmit={actionSouviner}>
                  {/* } */}
                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Title</>
                      </p>
                    </div>
                    <div className="col-md-9">
                      <input
                        className="form-control  reply-control"
                        type="text"
                        name="title"
                        value={title}
                        placeholder="Enter title"
                        onChange={(event) => {
                          setTitle(event.target.value);
                        }}
                      />
                      <span className="text-danger buTon-abc">
                        {errorList.title}
                      </span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Select Super Star</>
                      </p>
                    </div>
                    <div className="col-md-9">
                      <select
                        onChange={(event) => {
                          setStarId(event.target.value);
                        }}
                        name="superstar_id"
                        value={starId}
                        className="form-control reply-control"
                      >
                        <option className="text-black" value="">
                          Choose One
                        </option>
                        {starList?.map((user, index) => (
                          <option className="text-black" value={user.id}>
                            {user.first_name} {user.last_name}
                          </option>
                        ))}
                      </select>
                      <span className="text-danger">{errorList.star_id}</span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Description</>
                      </p>
                    </div>
                    <div className="col-md-9">
                      <CKEditor
                        name=""
                        data={description}
                        editor={ClassicEditor}
                        value={description}
                        onChange={(event, editor) => {
                          setDescription(editor.getData());
                        }}
                      />
                      <span className="text-danger buTon-abc">
                        {errorList.description}
                      </span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Instruction</>
                      </p>
                    </div>
                    <div className="col-md-9">
                      <CKEditor
                        name=""
                        data={instruction}
                        editor={ClassicEditor}
                        value={instruction}
                        onChange={(event, editor) => {
                          setInstruction(editor.getData());
                        }}
                      />
                      <span className="text-danger buTon-abc">
                        {errorList.instruction}
                      </span>
                    </div>
                  </div>

                  <div className="row my-4 ">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Banner</>
                      </p>
                    </div>
                    <div className="col-md-5">
                    {fileUrl && file? (
                        <div className="position-relative">
                    
                          <img
                          src={fileUrl}
                          className="img-fluid avatar-img-src"
                          alt=""
                          style={{ maxHeight: "300px" }}
                        />  
                       <span className="text-warning right-cross-button" onClick={deleteFile}>X</span>
                        </div>
                      ) : (
                        <img
                          src={imageCdnUrl + filePath}
                          className="img-fluid avatar-img-src"
                          alt=""
                          style={{ maxHeight: "300px" }}
                        />
                      )}

<input
                        type="file"
                        className="form-control reply-control"
                        onChange={(e) => handleImageChange(e.target.files)}
                        id="image"
                        name="image"
                        ref={fileInputRef}
                      />
                             {file && !fileUrl && <MediaUploadProgressBar progress={progress} />}
                      <span className="text-danger buTon-abc">
                        {errorList.banner}
                      </span>
                    </div>
                  </div>
{/* 
                  <div className="row">
                    <div className="col-md-3 label-text">
                      <p className="">
                        <>Video</>
                      </p>
                    </div>
                    <div className="col-md-5">
                      {showFileVideo ? (
                        <ReactPlayer
                          url={showFileVideo}
                          playing={true}
                          volume={1}
                          width="300px"
                          height="200px"
                        />
                      ) : (
                        ""
                      )}
                      <input
                        type="file"
                        className="form-control reply-control"
                        onChange={(event) => {
                          setVideo(event.target.files[0]);
                          setShowFileVideo(
                            URL.createObjectURL(event.target.files[0])
                          );
                        }}
                      />

                      <span className="text-danger buTon-abc">
                        {errorList.video}
                      </span>
                    </div>
                  </div> */}

                  <div className="row ">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Cost</>
                      </p>
                    </div>
                    <div className="col-md-9">
                      <input
                        className="form-control reply-control"
                        type="number"
                        name="cost"
                        placeholder="Enter fee $"
                        value={price}
                        onChange={(event) => {
                          setPrice(event.target.value);
                        }}
                      />
                      <span className="text-danger buTon-abc">
                        {errorList.price}
                      </span>
                    </div>
                  </div>

                  <div className="row ">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Tax</>
                      </p>
                    </div>
                    <div className="col-md-9">
                      <input
                        className="form-control reply-control"
                        type="text"
                        name="tax"
                        placeholder="Enter tax amount"
                        value={tax}
                        onChange={(event) => {
                          setTax(event.target.value);
                        }}
                      />
                      <span className="text-danger buTon-abc">
                        {errorList.tax}
                      </span>
                    </div>
                  </div>

                  {location.pathname ===
                  `/superstar-admin/souvenir/edit/${id}` ? (
                    <div className="row justify-content-center aligns-items-center my-4 mt-5">
                      <div className="col-md-3"></div>
                      <div className="col-md-9 d-flex justify-content-center aligns-items-center">
                        {loading ? (
                          <>
                            <button className="btn btnUpdate">
                              <i className="fas fa-spinner fa-pulse"></i>{" "}
                            </button>
                          </>
                        ) : (
                          <button
                            className="btn btnUpdate fw-bold"
                            type="submit"
                          >
                            Update
                          </button>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className="row justify-content-center aligns-items-center my-4 ">
                      <div className="col-md-3"></div>
                      <div className="col-md-9 d-flex justify-content-center aligns-items-center">
                        {loading ? (
                          <>
                            <button className="btn btnCreate">
                              <i className="fas fa-spinner fa-pulse"></i>{" "}
                            </button>
                          </>
                        ) : (
                          <button
                            className="btn btnCreate fw-bold"
                            type="submit"
                          >
                            Save
                          </button>
                        )}
                      </div>
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateEditSouvenir;
